export default __webpack_public_path__ + "static/media/Leg_left.e027a6f5.svg";